import { render, staticRenderFns } from "./mode-rule.vue?vue&type=template&id=03518c4a&scoped=true&"
import script from "./mode-rule.vue?vue&type=script&lang=js&"
export * from "./mode-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03518c4a",
  null
  
)

export default component.exports